import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _assignInstructorToProgramRequest = {};
var _assignInstructorToProgramResponse = {};
var _changeProgramInstructorsRequest = {};
var _changeProgramInstructorsResponse = {};
var _createInstructorRequest = { instructor: '_instructor' };
var _createInstructorResponse = { instructor: '_instructor' };
var _deleteInstructorRequest = {};
var _deleteInstructorResponse = { instructor: '_instructor' };
var _instructor = { createdDate: 'google.protobuf.Timestamp' };
var _inviteInstructorRequest = {};
var _inviteInstructorResponse = {};
var _listInstructorsRequest = {};
var _listInstructorsResponse = { instructors: '_instructor' };
var _queryInstructorsRequest = {};
var _queryInstructorsResponse = { instructors: '_instructor' };
var _unassignInstructorFromProgramRequest = {};
var _unassignInstructorFromProgramResponse = {};
var _updateInstructorRequest = { instructor: '_instructor' };
var _updateInstructorResponse = { instructor: '_instructor' };
function resolveWixAchievementsInstructorsV2InstructorsServiceUrl(opts) {
    var domainToMappings = {
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/instructors-service',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/instructors-service',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/instructors-service',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/instructors-service',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/instructors-service',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/instructors-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a new instructor */
export function createInstructor(payload) {
    var _a = serializer(_createInstructorRequest, { _instructor: _instructor }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createInstructorResponse, {
        _instructor: _instructor,
    }).fromJSON;
    function __createInstructor(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.achievements.instructors.v2.instructor',
            method: 'POST',
            methodFqn: 'wix.achievements.instructors.v2.InstructorsService.CreateInstructor',
            url: resolveWixAchievementsInstructorsV2InstructorsServiceUrl({
                protoPath: '/v2/instructors',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createInstructor.fromReq = fromReq;
    __createInstructor.__isAmbassador = true;
    return __createInstructor;
}
/** Invite instructor by provided email */
export function inviteInstructor(payload) {
    var _a = serializer(_inviteInstructorRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_inviteInstructorResponse, {}).fromJSON;
    function __inviteInstructor(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.achievements.instructors.v2.instructor',
            method: 'POST',
            methodFqn: 'wix.achievements.instructors.v2.InstructorsService.InviteInstructor',
            url: resolveWixAchievementsInstructorsV2InstructorsServiceUrl({
                protoPath: '/v2/instructors/invite',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __inviteInstructor.fromReq = fromReq;
    __inviteInstructor.__isAmbassador = true;
    return __inviteInstructor;
}
/** Lists instructors created on the site */
export function listInstructors(payload) {
    var _a = serializer(_listInstructorsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listInstructorsResponse, {
        _instructor: _instructor,
    }).fromJSON;
    function __listInstructors(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.achievements.instructors.v2.instructor',
            method: 'POST',
            methodFqn: 'wix.achievements.instructors.v2.InstructorsService.ListInstructors',
            url: resolveWixAchievementsInstructorsV2InstructorsServiceUrl({
                protoPath: '/v2/instructors/list',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listInstructors.fromReq = fromReq;
    __listInstructors.__isAmbassador = true;
    return __listInstructors;
}
/** Query instructors */
export function queryInstructors(payload) {
    var _a = serializer(_queryInstructorsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryInstructorsResponse, {
        _instructor: _instructor,
    }).fromJSON;
    function __queryInstructors(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.achievements.instructors.v2.instructor',
            method: 'POST',
            methodFqn: 'wix.achievements.instructors.v2.InstructorsService.QueryInstructors',
            url: resolveWixAchievementsInstructorsV2InstructorsServiceUrl({
                protoPath: '/v2/instructors/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryInstructors.fromReq = fromReq;
    __queryInstructors.__isAmbassador = true;
    return __queryInstructors;
}
/** Updates an instructor, supports partial update */
export function updateInstructor(payload) {
    var _a = serializer(_updateInstructorRequest, { _instructor: _instructor }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateInstructorResponse, {
        _instructor: _instructor,
    }).fromJSON;
    function __updateInstructor(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.achievements.instructors.v2.instructor',
            method: 'PATCH',
            methodFqn: 'wix.achievements.instructors.v2.InstructorsService.UpdateInstructor',
            url: resolveWixAchievementsInstructorsV2InstructorsServiceUrl({
                protoPath: '/v2/instructors/{instructor.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateInstructor.fromReq = fromReq;
    __updateInstructor.__isAmbassador = true;
    return __updateInstructor;
}
/** Deletes an instructor */
export function deleteInstructor(payload) {
    var _a = serializer(_deleteInstructorRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteInstructorResponse, {
        _instructor: _instructor,
    }).fromJSON;
    function __deleteInstructor(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.achievements.instructors.v2.instructor',
            method: 'DELETE',
            methodFqn: 'wix.achievements.instructors.v2.InstructorsService.DeleteInstructor',
            url: resolveWixAchievementsInstructorsV2InstructorsServiceUrl({
                protoPath: '/v2/instructors/{instructorId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteInstructor.fromReq = fromReq;
    __deleteInstructor.__isAmbassador = true;
    return __deleteInstructor;
}
/** Assigns an instructor to the program */
export function assignInstructorToProgram(payload) {
    var _a = serializer(_assignInstructorToProgramRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_assignInstructorToProgramResponse, {}).fromJSON;
    function __assignInstructorToProgram(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.achievements.instructors.v2.instructor',
            method: 'POST',
            methodFqn: 'wix.achievements.instructors.v2.InstructorsService.AssignInstructorToProgram',
            url: resolveWixAchievementsInstructorsV2InstructorsServiceUrl({
                protoPath: '/v2/instructors/{instructorId}/assign',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __assignInstructorToProgram.fromReq = fromReq;
    __assignInstructorToProgram.__isAmbassador = true;
    return __assignInstructorToProgram;
}
/** Unassigns an instructor from the program */
export function unassignInstructorFromProgram(payload) {
    var _a = serializer(_unassignInstructorFromProgramRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_unassignInstructorFromProgramResponse, {}).fromJSON;
    function __unassignInstructorFromProgram(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.achievements.instructors.v2.instructor',
            method: 'POST',
            methodFqn: 'wix.achievements.instructors.v2.InstructorsService.UnassignInstructorFromProgram',
            url: resolveWixAchievementsInstructorsV2InstructorsServiceUrl({
                protoPath: '/v2/instructors/{instructorId}/unassign',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __unassignInstructorFromProgram.fromReq = fromReq;
    __unassignInstructorFromProgram.__isAmbassador = true;
    return __unassignInstructorFromProgram;
}
/** Assigns or unassigns instructors to the program */
export function changeProgramInstructors(payload) {
    var _a = serializer(_changeProgramInstructorsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_changeProgramInstructorsResponse, {}).fromJSON;
    function __changeProgramInstructors(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.achievements.instructors.v2.instructor',
            method: 'POST',
            methodFqn: 'wix.achievements.instructors.v2.InstructorsService.ChangeProgramInstructors',
            url: resolveWixAchievementsInstructorsV2InstructorsServiceUrl({
                protoPath: '/v2/assignments',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __changeProgramInstructors.fromReq = fromReq;
    __changeProgramInstructors.__isAmbassador = true;
    return __changeProgramInstructors;
}
//# sourceMappingURL=http.impl.js.map